import { DangerousGoodsDefinitionDto, UnitLabelType } from '@planning/app/api'
import { FieldStore, ISubFormStore, requiredArray, validateSubForm } from '@tom-ui/utils'
import { action, makeObservable } from 'mobx'

export type DangerousGoodsSubFormType = {
  isDangerous: boolean
  imoClasses?: string[]
  unNumbers?: DangerousGoodsDefinitionDto[]
  otherLabels?: UnitLabelType[]
}

export class DangerousGoodsSubFormStore implements ISubFormStore<DangerousGoodsSubFormType> {
  isDangerous: FieldStore<boolean>
  imoClasses: FieldStore<string[]>
  unNumbers: FieldStore<DangerousGoodsDefinitionDto[]>
  otherLabels: FieldStore<UnitLabelType[]>

  constructor(initialValues?: Partial<DangerousGoodsSubFormType>) {
    makeObservable(this, {
      setSelectedUnNumbers: action,
    })

    this.isDangerous = new FieldStore<boolean>(initialValues?.isDangerous ?? false)
    this.imoClasses = new FieldStore<string[]>(initialValues?.imoClasses ?? [], requiredArray)
    this.unNumbers = new FieldStore<DangerousGoodsDefinitionDto[]>(initialValues?.unNumbers ?? [])
    this.otherLabels = new FieldStore<UnitLabelType[]>(
      initialValues?.otherLabels ?? [],
      requiredArray,
    )
  }

  setSelectedUnNumbers = (unNumbers: DangerousGoodsDefinitionDto[]) => {
    this.unNumbers.setValue(unNumbers)
    // Extract and combine IMO classes from selected UN numbers
    const newImoClasses = [
      ...unNumbers.flatMap(un => un.primaryImoClass || []),
      ...unNumbers.flatMap(un => un.secondaryImoClasses || []),
    ]

    // Combine and remove duplicates
    const updatedAssignedCodes = [...new Set([...this.imoClasses.value, ...newImoClasses])]
    this.imoClasses.setValue(updatedAssignedCodes)
  }

  validate = () => {
    if (!this.isDangerous.value) return true
    return validateSubForm(this)
  }

  get data() {
    if (!this.isDangerous.data) return { isDangerous: this.isDangerous.data }
    return {
      isDangerous: this.isDangerous.data,
      imoClasses: this.imoClasses.data,
      unNumbers: this.unNumbers.data,
      otherLabels: this.otherLabels.data,
    }
  }
}
